import { GramId } from "./config";
import React, { useEffect, useState } from "react";
import {
  createStyles,
  Theme,
  makeStyles,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@material-ui/core";

export type InstaMedia = {
  id: string;
  caption: string;
  media_type: string;
  media_url: string;
};

export type InstaQuery = {
  data: InstaMedia[];
};

const useStyles = makeStyles((t: Theme) => ({
  main: {
    margin: t.spacing(3, 2, 3, 1),
  },
  photo: {
    margin: t.spacing(2, 0),
  },
}));

export function InstaFeed() {
  const [media, setMedia] = useState<InstaMedia[]>();
  const classes = useStyles();
  useEffect(() => {
    fetch(
      `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url&access_token=${encodeURIComponent(
        GramId
      )}`
    ).then((r) => r.text().then((t) => processQuery(JSON.parse(t))));
  }, []);

  function processQuery(q: InstaQuery) {
    setMedia(q.data);
  }
  return (
    <div className={classes.main}>
      <Typography variant="h5" align="center">
        @thewinstonbar
      </Typography>
      {media &&
        media.map((v) => (
          <Card key={v.id} className={classes.photo}>
            <CardMedia>
              <img src={v.media_url} style={{ width: "100%" }} />
            </CardMedia>
            <CardContent>
              <Typography>{v.caption}</Typography>
            </CardContent>
          </Card>
        ))}
    </div>
  );
}
